<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('usertype')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATEUSERTYPE' | translate) : ('TR_EDITUSERTYPE' | translate) }}</h5> 
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="form-row">
        <div class="col-lg-3 col-md-4">
          <div class="position-relative form-group">
            <label for="name">{{('TR_USERTYPE' | translate) + mainService.asterisk}}</label>
            <input
              [class.error-border]="isInvalidSubmit && !form.value.name"
              name="name"
              [placeholder]="('TR_USERTYPE' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              autocomplete="off"
              formControlName="name"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-6 col-md-6 col-12">
          <div class="main-card mb-3 card">
            <div class="card-header">
              <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
                {{ 'TR_SELECTDEF_USERTYPES' | translate }}
              </div>
            </div>
            <div class="table-responsive">
              <table class="align-middle mb-0 table table-striped table-hover">
                <tbody>
                  <tr *ngFor="let item of defaultUserTypes">
                    <td>
                      <label class="pointer" [htmlFor]="item.name">{{ item.name }}</label>
                    </td>
                    <td>
                      <input [id]="item.name" [name]="item.name" type="checkbox" class="mt-2 pointer" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>